import { useTranslate } from '@im/react-localization';
import { ProductsHover } from '@im/ui-lib/icons/nav/Products';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import { isEmbedded } from '../../../util';

export default function NoResultsScreen(params: any) {
  const translate = useTranslate();
  return (
    <Stack
      alignItems="center"
      data-testid="no-results-screen"
      flexWrap="wrap"
      gap={1}
      height={isEmbedded() ? '100vh' : `calc(100vh - 150px)`}
      justifyContent="center"
      margin="auto"
    >
      <ProductsHover
        sx={(theme) => ({
          fontSize: `calc(${theme.typography.body1.fontSize} * 5)`,
        })}
      />
      <Typography
        sx={(theme) => ({
          fontSize: theme.typography.h5.fontSize,
          fontWeight: theme.typography.fontWeightBold,
          lineHeight: `calc(${theme.typography.h5.fontSize} + 4px)`,
        })}
      >
        {translate('Common.SearchNoResults')}
      </Typography>
      <Typography
        sx={(theme) => ({
          fontSize: theme.typography.body2.fontSize,
          lineHeight: theme.typography.body2.lineHeight,
        })}
      >
        {translate('VendorDeals.SearchResultsPlaceholder')}
      </Typography>
    </Stack>
  );
}
